const CryptoJS = require('crypto-js/core')
require('crypto-js/aes')
require('crypto-js/pad-zeropadding')

function parse(str) {
  return CryptoJS.enc.Utf8.parse(str)
}
const KEY = ''
const IV = ''
// keyStr = '&Pm9N4Sx@9tRtCvl', ivStr = 'jlOgDzPeZ9X!qC7M'
function Decrypt(word, ext = {}) {
  const key = parse(ext.key || KEY)
  const iv = parse(ext.iv || IV)
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

function Encrypt(word, ext = {}) {
  const key = parse(ext.key || KEY)
  const iv = parse(ext.iv || IV)
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  // encrypted.ciphertext.toString().toUpperCase()
  let baseStr = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
  return baseStr
}

function obj() {
  return {
    key: 'KCr@AvIXMbDnWTBV',
    iv: '1234567890123456'
  }
}
// const obj = {
//   key: 'KCr@AvIXMbDnWTBV',
//   iv: '1234567890123456'
// }

export default {
  Decrypt,
  Encrypt,
  obj
}



// WEBPACK FOOTER //
// ./src/lib/Utils/AES.js